import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  atropinApplication,
  getAllSubCategory,
  getCategory,
  getProducts,
  getSubCategory,
  searchQ,
  UserDetail,
} from "../axios";
import logo from "./../assets/img/logo/new-logo.png";
import phoneIcon from "../assets/img/header-icons/phone-icon.png";
import shoppingBag from "../assets/img/icon/shopping-basket.png";
// import AppStore from "../store/context";
import { separate } from "../tools/helper";
import ScrollToTop from "./ScrollTop";
import { CartContext } from "./shared/context/cart-context";
import { ShoppingContext } from "./shared/context/shopping-context";

const Header = () => {
  const {
    setProductsBySubCategory,
    setFlashId,
    setSubCategory,
    setFlashCartModal,
    classes,
    setClasses,
    setStyles,
    setSelectTypeCategory,
    callNewCategories,
  } = useContext(ShoppingContext);
  const location = useLocation();
  const [products, setProducts] = useState();
  const [allSubCategories, setAllSubCategories] = useState([]);
  const [activeNavItem, setActiveNavItem] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);

  const phoneNumber = localStorage.getItem("phonenumber")

  //getting all subCategories for navBar
  useEffect(() => {
    const fetchData = async () => {
      try {
        // const [
        //   { data: result1 },
        //   { data: result2 },
        //   { data: result3 },
        //   { data: result4 },
        //   { data: result5 },
        // ] = await Promise.all([
        //   getSubCategory(1),
        //   getSubCategory(2),
        //   getSubCategory(3),
        //   getSubCategory(10),
        //   getSubCategory(11)
        // ]);
        const { data } = await getAllSubCategory();

        // const combinedResult = [...result1, ...result2, ...result3, ...result4, ...result5];
        // console.log("subcatsssssssss", data);

        if (data.length > 0) setAllSubCategories(data);
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    let subCategoryId = location.search.split("=")[1];
    setSelectTypeCategory(subCategoryId);
    setFlashCartModal(false);
    if (
      subCategoryId == 1 ||
      subCategoryId == 2 ||
      subCategoryId == 3 ||
      subCategoryId == 4
    ) {
      getProducts().then(({ data }) => {
        // console.log(data);
        setProducts(data);

        const filterProducts = data?.filter(
          (p) => p.categoryID == subCategoryId
        );

        if (filterProducts) {
          filterProducts.sort(function (a, b) {
            if (a.subCategoryID < b.subCategoryID) {
              return -1;
            }
            if (a.subCategoryID > b.subCategoryID) {
              return 1;
            }
            // sub category must be equal
            return 0;
          });
        }

        setProductsBySubCategory(filterProducts);
      });

      getSubCategory(subCategoryId).then(({ data }) => {
        setSubCategory(data);
      });

      if (subCategoryId == 4) {
        setFlashId(4);
        modalVisibleOrInvisible();
      }
    }
  }, [location.search]);

  //handling toggle menu items like shop and exams
  const handleToggleMenuItems = (value) => {
    value === activeNavItem ? setActiveNavItem(null) : setActiveNavItem(value);
  };

  //handling toggle categoriey items in shop menu
  const handleToggleCategories = (value) => {
    value === activeCategory
      ? setActiveCategory(null)
      : setActiveCategory(value);
  };

  function modalVisibleOrInvisible() {
    if (classes === "modal fade") {
      setClasses("modal fade show");
      setStyles("block");
    } else {
      setClasses("modal fade");
      setStyles("none");
    }
  }

  const [categorySet, setCategorySet] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  // ------------------------------------------- CartContext
  const [cartItems] = useContext(CartContext);

  const [flashCartContainer, setFlashCartContainer] = useState([]);

  useEffect(() => {
    const ids = new Set();
    const result = cartItems.filter((obj) => {
      if (obj.categoryID === 4) {
        if (ids.has(obj.id)) {
          return false; // remove object
        }
        ids.add(obj.id);
        return true; // keep object
      }
    });
    setFlashCartContainer(result);
  }, [cartItems]);

  // useEffect(() => {

  //   let array = [...flashCartContainer];
  //   cartItems.map((item) => {
  //     if (item.categoryID === 4) {
  //       array.push(item);
  //     }
  //   });
  //   setFlashCartContainer(array);
  // }, [cartItems]);

  // -------------------------------------------

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data : userRes } = await UserDetail(phoneNumber); // call userDetail api
        const user = userRes?.find((u) => u.type === "کاربر سایت");
        
        const { data } = await getCategory();

        let filteredData = data.filter((item) => item.id !== 8); // delete azmoon category

        if (user.maghta === "مقاطع بالاتر") {
          filteredData = filteredData.filter(
            (item) => item.isOlomPaye === false
          );
        }

        setCategorySet(filteredData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  // useEffect(() => {
  //   console.log("location.pathname", location.pathname);
  //   if (location.pathname) {
  //     setClasses("Offcanvas_menu_wrapper");
  //     ScrollToTop(500);
  //   }
  // }, [location.pathname]);

  const onclickMenuItems = () => {
    setClasses("Offcanvas_menu_wrapper");
  };

  const handelMenu = () => {
    if (classes === "Offcanvas_menu_wrapper") {
      setClasses("Offcanvas_menu_wrapper active");
    } else {
      setClasses("Offcanvas_menu_wrapper");
    }
  };

  const appDownloadHandler = () => {
    try {
      atropinApplication()
        .then((res) => {
          const url = res.data;
          const link = document.createElement("a");
          link.href = url;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <React.Fragment>
      <div className="Offcanvas_menu">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div
                className="canvas_open"
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
                  gap: 20,
                }}
              >
                <a onClick={handelMenu}>
                  <i className="ion-navicon"></i>
                </a>
                {/* ------------------------- آیکون سبد خرید --------------------- */}
                {/* style={{ position: "relative", backgroundColor: "red" }} */}
                <div className="mini_cart_wrapper">
                  <Link to="/card" style={{ color: "red", border: "none" }}>
                    <img width="35" src={shoppingBag} />
                    <span
                      className="cart_quantity"
                      style={{ textAlign: "center", alignItems: "center" }}
                    >
                      {cartItems.length}
                    </span>
                  </Link>
                </div>

                {/* ------------------------------------------------- */}
              </div>
              <div
                onClick={handelMenu}
                class={
                  classes === "Offcanvas_menu_wrapper active"
                    ? "menu-fade-overlay"
                    : ""
                }
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  className={`${classes} hideScrollbar`}
                >
                  <div className="canvas_close">
                    <a onClick={handelMenu}>
                      <i className="ion-android-close"></i>
                    </a>
                  </div>
                  <div className="support_info">
                    <img className="phone_icon" src={phoneIcon} />
                    <p>
                      تلفن تماس:{" "}
                      <a className="ltr-text" href="tel:+989214104104">
                        0921-4-104104
                      </a>
                    </p>
                  </div>
                  <div className="top_right text-right">
                    <ul style={{ paddingLeft: 0 }}>
                      {" "}
                      <li>
                        <Link to="/install-guide">نصب وب اپلیکیشین</Link>
                      </li>
                      <li>
                        <Link to="/webinar">
                          {" "}
                     وبینار های آتروپین {" "}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/login"
                          onClick={() => {
                            onclickMenuItems();
                          }}
                        >
                          حساب کاربری
                        </Link>
                      </li>
                      <li className="py-1">
                        {/* href={ApplicationAtropin} download */}
                        {/* <a
                          href="https://drive.google.com/file/d/18ClUyIH3nVORHVZ96j7M61pHX4KpIZrS/view"
                          target="_blank"
                        > */}
                        {/* <button
                          onClick={appDownloadHandler}
                          className="btn btn-outline-info"
                          style={{
                            padding: "10px 5px 10px 5px",
                            borderRadius: "30px",
                            margin: "10px auto",
                          }}
                          title="اپلیکیشن آتروپین نسخه اندروید"
                        >
                          اپلیکیشن آتروپین نسخه اندروید
                        </button> */}
                        {/* </a> */}
                      </li>
                    </ul>
                  </div>
                  <div className="search_container">
                    <form action="#">
                      <div className="search_box">
                        <input
                          onChange={(e) => setSearch(e.target.value)}
                          value={search}
                          placeholder="جستجوی محصول ..."
                          type="text"
                        ></input>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`/search/${search}`);
                          }}
                        >
                          جستجو
                        </button>
                      </div>
                    </form>
                  </div>
                  <div className="middel_right_info">
                    <div className="header_wishlist">
                      <Link
                        to="/wishlist"
                        onClick={() => {
                          onclickMenuItems();
                        }}
                      >
                        <i className="fa fa-heart-o" aria-hidden="true"></i>
                      </Link>
                    </div>
                    <div className="mini_cart_wrapper">
                      <Link
                        to="/card"
                        onClick={() => {
                          onclickMenuItems();
                        }}
                      >
                        <img width="35" src={shoppingBag} />
                        <i className="fa fa-angle-down"></i>
                      </Link>
                      {cartItems.length > 0 && (
                        <span className="cart_quantity">
                          {/* {cartItems.length} */}
                        </span>
                      )}
                      <div className="mini_cart">
                        <div className="cart_items_container">
                          {flashCartContainer.length > 0 && (
                            <div className="cart_item">
                              <div className="cart_img">
                                <a href="#">
                                  <img
                                    src={flashCartContainer[0]?.img}
                                    alt=""
                                  />
                                </a>
                              </div>
                              <div className="cart_info">
                                <Link
                                  onClick={() => {
                                    onclickMenuItems();
                                  }}
                                  to={`/product/${flashCartContainer[0]?.id}`}
                                >
                                  {flashCartContainer[0]?.title}
                                </Link>
                                <p>
                                  <span>
                                    {separate(flashCartContainer?.length) *
                                      separate(
                                        flashCartContainer[0]?.priceTakhfif
                                      )}
                                    تومان
                                  </span>
                                </p>
                              </div>
                            </div>
                          )}
                          {cartItems?.map((item, index) => {
                            item.categoryID !== 4 && (
                              <div key={index} className="cart_item">
                                <div className="cart_img">
                                  <a href="#">
                                    <img src={item.img} alt="" />
                                  </a>
                                </div>
                                <div className="cart_info">
                                  <Link
                                    to={`/product/${item.id}`}
                                    onClick={() => {
                                      onclickMenuItems();
                                    }}
                                  >
                                    {item.title}
                                  </Link>
                                  <p>
                                    <span>
                                      {" "}
                                      {separate(item.priceTakhfif)} تومان{" "}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                        <div className="mini_cart_footer">
                          <div className="cart_button">
                            <Link
                              to="/card"
                              onClick={() => {
                                onclickMenuItems();
                              }}
                            >
                              مشاهده سبد
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="menu" className="text-left ">
                    <ul className="offcanvas_main_menu">
                      <li className="menu-item-has-children active">
                        <Link
                          to="/"
                          onClick={() => {
                            onclickMenuItems();
                          }}
                        >
                          خانه
                        </Link>
                      </li>
                      <li className="menu-item-has-children">
                        <Link onClick={() => handleToggleMenuItems("shop")}>
                          فروشگاه<i className="fa fa-angle-down"></i>
                        </Link>
                        {activeNavItem === "shop" ? (
                          <ul className="sub-menu">
                            <li className="menu-item-has-children">
                              <ul className="sub_menu p-0">
                                {categorySet.map((item1, index) => (
                                  <li key={index}>
                                    <Link
                                      to={
                                        item1.id === 4
                                          ? `/shop?catId=${item1.id}`
                                          : ""
                                      }
                                      onClick={() => {
                                        if (item1.id === 4) {
                                          callNewCategories(item1.id, products);
                                          onclickMenuItems();
                                        }
                                        handleToggleCategories(item1.id);
                                      }}
                                    >
                                      {item1.categoryTitle}
                                      {item1.id !== 4 ? (
                                        <i className="fa fa-angle-down"></i>
                                      ) : null}
                                    </Link>
                                    {allSubCategories &&
                                    item1.id !== 4 &&
                                    activeCategory === item1.id ? (
                                      <ul className="subCategories_sub_menu p-0">
                                        {item1.id === 1 && (
                                          <li key={item1.id}>
                                            <Link
                                              className="mobileMenu-subcategories"
                                              onClick={onclickMenuItems}
                                              to={`/shop?catId=${item1.id}`}
                                            >
                                              تمام کتاب ها
                                            </Link>
                                          </li>
                                        )}
                                        {item1.id === 2 && (
                                          <li key={item1.id}>
                                            <Link
                                              className="mobileMenu-subcategories"
                                              onClick={onclickMenuItems}
                                              to={`/shop?catId=${item1.id}`}
                                            >
                                              تمام کتاب های الکترونیک
                                            </Link>
                                          </li>
                                        )}
                                        {item1.id === 3 && (
                                          <li key={item1.id}>
                                            <Link
                                              className="mobileMenu-subcategories"
                                              onClick={onclickMenuItems}
                                              to={`/shop?catId=${item1.id}`}
                                            >
                                              تمام تدریس ها
                                            </Link>
                                          </li>
                                        )}
                                        {item1.id === 12 && (
                                          <li key={item1.id}>
                                            <Link
                                              className="mobileMenu-subcategories"
                                              onClick={onclickMenuItems}
                                              to={`/shop?catId=${item1.id}`}
                                            >
                                              تمام آتروفست ها {"(دیجیتال)"}
                                            </Link>
                                          </li>
                                        )}
                                        {item1.id === 14 && (
                                          <li key={item1.id}>
                                            <Link
                                              className="mobileMenu-subcategories"
                                              onClick={onclickMenuItems}
                                              to={`/shop?catId=${item1.id}`}
                                            >
                                              تمام آتروفست ها {"(چاپی)"}
                                            </Link>
                                          </li>
                                        )}
                                        {allSubCategories
                                          .filter(
                                            (subCategory) =>
                                              subCategory.categoryID ===
                                              item1.id
                                          )
                                          .map((item2) => (
                                            <li key={item2.id}>
                                              <Link
                                                className="mobileMenu-subcategories"
                                                onClick={onclickMenuItems}
                                                to={
                                                  item1.id === 10
                                                    ? `/consultation?scrollPackages=${item2.id}`
                                                    : `/shop?catId=${item1.id}&subCatId=${item2.id}`
                                                }
                                              >
                                                {item2.subCategoryTitle}
                                              </Link>
                                            </li>
                                          ))}
                                      </ul>
                                    ) : null}
                                  </li>
                                ))}
                              </ul>
                            </li>
                          </ul>
                        ) : null}
                      </li>
                      {/* <li className="menu-item-has-children">
                        <Link onClick={() => handleToggleMenuItems("olomPaye")}>
                          علوم پایه<i className="fa fa-angle-down"></i>
                        </Link>
                        {activeNavItem === "olomPaye" ? (
                          <ul className="sub-menu">
                            <li className="menu-item-has-children">
                              <ul className="sub_menu p-0">
                                {categorySet?.filter(item => item.isOlomPaye).map((item1, index) => (
                                  <li key={index}>
                                    <Link
                                      to={
                                        item1.id === 4
                                          ? `/shop?catId=${item1.id}`
                                          : ""
                                      }
                                      onClick={() => {
                                        if (item1.id === 4) {
                                          callNewCategories(item1.id, products);
                                          onclickMenuItems();
                                        }
                                        handleToggleCategories(item1.id);
                                      }}
                                    >
                                      {item1.categoryTitle}
                                      {item1.id !== 4 ? (
                                        <i className="fa fa-angle-down"></i>
                                      ) : null}
                                    </Link>
                                    {allSubCategories &&
                                    item1.id !== 4 &&
                                    activeCategory === item1.id ? (
                                      <ul className="subCategories_sub_menu p-0">
                                        {item1.id === 1 && (
                                          <li key={item1.id}>
                                            <Link
                                              className="mobileMenu-subcategories"
                                              onClick={onclickMenuItems}
                                              to={`/shop?catId=${item1.id}`}
                                            >
                                              تمام کتاب ها
                                            </Link>
                                          </li>
                                        )}
                                        {item1.id === 2 && (
                                          <li key={item1.id}>
                                            <Link
                                              className="mobileMenu-subcategories"
                                              onClick={onclickMenuItems}
                                              to={`/shop?catId=${item1.id}`}
                                            >
                                              تمام کتاب های الکترونیک
                                            </Link>
                                          </li>
                                        )}
                                        {item1.id === 3 && (
                                          <li key={item1.id}>
                                            <Link
                                              className="mobileMenu-subcategories"
                                              onClick={onclickMenuItems}
                                              to={`/shop?catId=${item1.id}`}
                                            >
                                              تمام تدریس ها
                                            </Link>
                                          </li>
                                        )}
                                        {allSubCategories
                                          .filter(
                                            (subCategory) =>
                                              subCategory.categoryID ===
                                              item1.id
                                          )
                                          .map((item2) => (
                                            <li key={item2.id}>
                                              <Link
                                                className="mobileMenu-subcategories"
                                                onClick={onclickMenuItems}
                                                to={
                                                  item1.id === 10
                                                    ? `/consultation?scrollPackages=${item2.id}`
                                                    : `/shop?catId=${item1.id}&subCatId=${item2.id}`
                                                }
                                              >
                                                {item2.subCategoryTitle}
                                              </Link>
                                            </li>
                                          ))}
                                      </ul>
                                    ) : null}
                                  </li>
                                ))}
                              </ul>
                            </li>
                          </ul>
                        ) : null}
                      </li> */}
                      {/* <li className="menu-item-has-children">
                        <Link
                          to="/shop?id=1"
                          className="text-secondary"
                          onClick={() => {
                            onclickMenuItems();
                          }}
                        >
                          ازمون ها
                        </Link>
                        <ul className="sub-menu">
                          <li className="menu-item-has-children">
                            <ul className="sub_menu">
                              {examsSubItems.map((item) => (
                                <li key={item.id}>
                                  <Link
                                    to={item.path}
                                    className="text-secondary"
                                  >
                                    {item.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </li>
                        </ul>
                      </li> */}
                      <li className="menu-item-has-children">
                        <Link
                          to="/myLibrary"
                          className="text-red border border-2 rounded rounded-pill px-2 border-danger d-inline-block py-1"
                          onClick={() => {
                            onclickMenuItems();
                          }}
                        >
                          کتابخانه من
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/consultation"
                          onClick={() => {
                            onclickMenuItems();
                          }}
                        >
                          گروه مشاوره دستیاری آتروپین
                        </Link>
                      </li>
                      <li className="menu-item-has-children">
                        <Link
                          to="/blog"
                          onClick={() => {
                            onclickMenuItems();
                          }}
                        >
                          بلاگ
                        </Link>
                      </li>
                      <li className="menu-item-has-children">
                        <Link
                          to="https://azmoon.atropine.ir/"
                          target="_blank"
                          className="text-red border border-2 rounded rounded-pill px-2 border-danger d-inline-block py-1"
                          onClick={() => {
                            onclickMenuItems();
                          }}
                        >
                          سامانه آزمون{" "}
                        </Link>
                      </li>
                      <li className="menu-item-has-children">
                        <Link
                          to="/login"
                          onClick={() => {
                            onclickMenuItems();
                          }}
                        >
                          حساب کاربری
                        </Link>
                      </li>
                      <li className="menu-item-has-children">
                        <Link
                          to="/about"
                          onClick={() => {
                            onclickMenuItems();
                          }}
                        >
                          درباره ما
                        </Link>
                      </li>
                      <li className="menu-item-has-children">
                        <Link
                          to="/contact"
                          onClick={() => {
                            onclickMenuItems();
                          }}
                        >
                          تماس با ما
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="Offcanvas_footer">
                    <span>
                      <a href="#">
                        <i className="fa fa-envelope-o"></i>{" "}
                        Atropine.medical.education@gmail.com
                      </a>
                    </span>
                    <ul>
                      <li className="pinterest">
                        <a href="https://instagram.com/dr_nayebzade?r=nametag">
                          <i className="fa fa-instagram"></i>
                        </a>
                      </li>
                      <li className="telegram">
                        <a href="https://t.me/Atropine_admin">
                          <i className="fa fa-telegram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <header>
        <Link to="/card" class="float">
          <div className="mini_cart_wrapper">
            <img width="35" src={shoppingBag} />
            <span className="cart_quantity">{cartItems.length}</span>
          </div>
        </Link>
        <div className="main_header" style={{ position: "relative" }}>
          <div className="header_top">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6">
                  <div className="support_info">
                    <img className="phone_icon" src={phoneIcon} />
                    <p>
                      <span className="mr-2">شماره تماس آتروپین</span>
                      <a className="ltr-text" href="tel:+989214104104">
                        0921-4-104104
                      </a>
                    </p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6">
                  <div className="top_right text-right">
                    <ul className="pt-2">
                      <li>
                        <Link to="/install-guide">نصب وب اپلیکیشین</Link>
                      </li>
                      <li>
                        <Link to="/webinar">
                          {" "}
                   وبینار های آتروپین {" "}
                        </Link>
                      </li>
                      <li>
                        <Link to="/login"> حساب کاربری </Link>
                      </li>

                      <li className="py-1">
                        {/* <a
                          href="https://drive.google.com/file/d/18ClUyIH3nVORHVZ96j7M61pHX4KpIZrS/view"
                          target="_blank"
                        > */}
                        {/* <button
                          onClick={appDownloadHandler}
                          className="btn btn-outline-info"
                          style={{
                            padding: "10px 5px 10px 5px",
                            borderRadius: "30px",
                            margin: "10px auto",
                          }}
                          title="اپلیکیشن آتروپین نسخه اندروید"
                        >
                          اپلیکیشن آتروپین نسخه اندروید
                        </button> */}
                        {/* </a> */}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="header_middle">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-3 col-md-6">
                  <div className="logo">
                    <Link to="/">
                      <img src={logo} alt="" />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-9 col-md-6">
                  <div className="middel_right">
                    <div className="search_container">
                      <form action="#">
                        <div className="search_box">
                          <input
                            onChange={(e) => setSearch(e.target.value)}
                            value={search}
                            placeholder="جستجوی محصول ..."
                            type="text"
                          ></input>
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(`/search/${search}`);
                            }}
                          >
                            جستجو
                          </button>
                        </div>
                      </form>
                    </div>
                    <div className="middel_right_info">
                      <div className="header_wishlist">
                        {localStorage.getItem("login") ? (
                          <Link to="/wishlist">
                            <i className="fa fa-heart-o" aria-hidden="true"></i>
                          </Link>
                        ) : (
                          <Link to="/">
                            <i className="fa fa-heart-o" aria-hidden="true"></i>
                          </Link>
                        )}
                      </div>
                      <div className="mini_cart_wrapper">
                        <Link to="/card">
                          <img width="35" src={shoppingBag} />
                          <i className="fa fa-angle-down"></i>
                        </Link>
                        {cartItems.length > 0 && (
                          <span className="cart_quantity">
                            {/* {cartItems.length} */}
                          </span>
                        )}
                        <div className="mini_cart">
                          <div
                            className="cart_items_container"
                            style={{ overflowY: "auto" }}
                          >
                            {flashCartContainer.length > 0 && (
                              <div className="cart_item">
                                <div className="cart_img">
                                  <a href="#">
                                    <img
                                      src={flashCartContainer[0]?.img}
                                      alt=""
                                    />
                                  </a>
                                </div>
                                <div className="cart_info">
                                  <Link
                                    to={`/product/${flashCartContainer[0]?.id}`}
                                  >
                                    {flashCartContainer[0]?.title}
                                  </Link>
                                  <p>
                                    <span>
                                      {separate(flashCartContainer?.length) *
                                        separate(
                                          flashCartContainer[0]?.priceTakhfif
                                        )}
                                      تومان
                                    </span>
                                  </p>
                                </div>
                              </div>
                            )}
                            {cartItems?.map(
                              (item, index) =>
                                item.categoryID !== 4 && (
                                  <div key={index} className="cart_item">
                                    <div className="cart_img">
                                      <a href="#">
                                        <img src={item.img} alt="" />
                                      </a>
                                    </div>
                                    <div className="cart_info">
                                      <Link to={`/product/${item.id}`}>
                                        {item.title}
                                      </Link>
                                      <p>
                                        <span>
                                          {" "}
                                          {separate(
                                            item.priceTakhfif
                                          )} تومان{" "}
                                        </span>
                                      </p>
                                    </div>
                                  </div>
                                )
                            )}
                          </div>
                          <div className="mini_cart_footer">
                            <div className="cart_button">
                              <Link to="/card">مشاهده سبد</Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="main_menu_area">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-10 col-md-12">
                  <div className="main_menu menu_position">
                    <nav>
                      <ul className="nav_list">
                        <li>
                          <Link to="/">خانه</Link>
                        </li>
                        <li className="mega_items">
                          <p
                            className="fw-bold m-0"
                            style={{ color: "#fff", cursor: "pointer" }}
                          >
                            فروشگاه<i className="fa fa-angle-down"></i>
                          </p>

                          <ul className="sub_menu">
                            {categorySet.map((item1, index) => (
                              <li
                                className="parent_listItem d-flex align-items-center gap-1"
                                key={index}
                                onClick={() => {
                                  callNewCategories(item1.id, products);
                                }}
                              >
                                <Link
                                  to={
                                    item1.id == 10
                                      ? "/consultation?scrollPackages=73"
                                      : `/shop?catId=${item1.id}`
                                  }
                                >
                                  {item1.categoryTitle}
                                </Link>
                                {item1.id !== 4 ? (
                                  <i className="fa fa-angle-left"></i>
                                ) : null}
                                {allSubCategories && item1.id !== 4 ? (
                                  <ul
                                    className={
                                      item1.id === 10
                                        ? "subCategories_sub_menu moshavereh"
                                        : item1.isOlomPaye
                                        ? "subCategories_sub_menu olomPaye"
                                        : "subCategories_sub_menu"
                                    }
                                  >
                                    {allSubCategories
                                      .filter(
                                        (subCategory) =>
                                          subCategory.categoryID === item1.id
                                      )
                                      .map((item2, index2) => (
                                        <li key={index2}>
                                          <Link
                                            to={
                                              item2.categoryID === 10
                                                ? `/consultation?scrollPackages=${item2.id}`
                                                : `/shop?catId=${item1.id}&subCatId=${item2.id}`
                                            }
                                          >
                                            {item2.subCategoryTitle}
                                          </Link>
                                        </li>
                                      ))}
                                  </ul>
                                ) : null}
                              </li>
                            ))}
                          </ul>
                        </li>

                        {/* <li className="mega_items">
                          <p
                            className="fw-bold m-0"
                            style={{ color: "#fff", cursor: "pointer" }}
                          >
                            علوم پایه<i className="fa fa-angle-down"></i>
                          </p>

                          <ul className="sub_menu olomPaye">
                            {categorySet?.filter(item => item.isOlomPaye).map((item1, index) => (
                              <li
                                className="parent_listItem d-flex align-items-center gap-1"
                                key={index}
                                onClick={() => {
                                  callNewCategories(item1.id, products);
                                }}
                              >
                                <Link
                                  to={
                                     `/shop?catId=${item1.id}&maghta=op`
                                  }
                                >
                                  {item1.categoryTitle}
                                </Link>
                                {item1.id !== 4 ? (
                                  <i className="fa fa-angle-left"></i>
                                ) : null}
                                {allSubCategories && item1.id !== 4 ? (
                                  <ul
                                    className={
                                      item1.id === 10
                                        ? "subCategories_sub_menu moshavereh"
                                        : "subCategories_sub_menu"
                                    }
                                  >
                                    {allSubCategories
                                      .filter(
                                        (subCategory) =>
                                          subCategory.categoryID === item1.id
                                      )
                                      .map((item2, index2) => (
                                        <li key={index2}>
                                          <Link
                                            to={
                                                `/shop?catId=${item1.id}&subCatId=${item2.id}&maghta=op`
                                            }
                                          >
                                            {item2.subCategoryTitle}
                                          </Link>
                                        </li>
                                      ))}
                                  </ul>
                                ) : null}
                              </li>
                            ))}
                          </ul>
                        </li> */}

                        <li className="bordered-navItem">
                          <Link
                            className="border border-2 rounded rounded-pill px-2"
                            to="/myLibrary"
                          >
                            کتابخانه من
                          </Link>
                        </li>

                        {/* <li className="mega_items">
                          <p
                            className="fw-bold m-0"
                            style={{ color: "#fff", cursor: "pointer" }}
                          >
                            آزمون ها<i className="fa fa-angle-down"></i>
                          </p>

                          <ul className="sub_menu exams_subMenu">
                            {examsSubItems.map((item) => (
                              <li className="parent_listItem"
                                key={item.id}
                                
                              >
                                <Link to={item.path}>
                                  {item.title}
                                </Link>
                                {allSubCategories && item.id !== 4 ?  (
                                <ul className="subCategories_sub_menu">
                                    {allSubCategories.filter(subCategory => subCategory.categoryID === item.id).map(item => (
                                      <li key={item.id}><Link to={`/shop?id=${item.id}`}>{item.subCategoryTitle}</Link></li>
                                    ))}
                                </ul>) : null}
                              </li>
                            ))}
                          </ul>
                        </li> */}
                        <li>
                          <Link to="/consultation">
                            {" "}
                            گروه مشاوره دستیاری آتروپین
                          </Link>
                        </li>
                        <li>
                          <Link to="/blog"> بلاگ</Link>
                        </li>
                        <li>
                          <Link to="/about">درباره ما</Link>
                        </li>
                        <li>
                          <Link to="/contact"> تماس با ما</Link>
                        </li>

                        <li className="bordered-navItem">
                          <Link
                            className="border border-2 rounded rounded-pill px-2"
                            to="https://azmoon.atropine.ir/"
                            target="_blank"
                          >
                            سامانه آزمون
                          </Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
